/**
 * JWT token payload'ından groups bilgisini güvenli şekilde decode eder.
 * Yanıt gövdesindeki groups manipüle edilebileceğinden, her zaman
 * Keycloak'ın imzaladığı token'dan okuma yapılır.
 */
export function decodeGroupsFromJwt(accessToken: string): string[] {
  if (!accessToken) {
    return [];
  }
  try {
    const parts = accessToken.split('.');
    if (parts.length !== 3) {
      return [];
    }
    const payload = parts[1];
    // Base64url → Base64 dönüşümü
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
    const decoded = JSON.parse(atob(padded));
    return Array.isArray(decoded.groups) ? decoded.groups : [];
  } catch {
    return [];
  }
}
